// La pesée du lundi : un champ, une question (les fast-foods hors plan), un bouton.

import { useState } from 'react';

import type { PropsEcran } from '../App';
import { EnTeteRetour, Fenetre } from '../components';
import { kg, lirePoids } from '../lib/format';
import { VOCAB } from '../lib/theme';

export function Pesee({ etat, actions }: PropsEcran) {
  const [saisie, setSaisie] = useState('');
  const [fastfoods, setFastfoods] = useState(0);
  const [envoi, setEnvoi] = useState(false);
  const poids = lirePoids(saisie);

  const valider = async () => {
    if (poids === null) return;
    setEnvoi(true);
    const ecart = etat.statut.poidsActuel !== null ? Math.round((poids - etat.statut.poidsActuel) * 10) / 10 : null;
    const ok = await actions.pesee(
      { date: etat.date, poids, fastfoods },
      ecart === null || ecart === 0 ? `Pesée notée : ${kg(poids)}.` : `Pesée notée : ${kg(poids)} (${ecart > 0 ? '+' : ''}${String(ecart).replace('.', ',')} kg).`,
    );
    setEnvoi(false);
    if (ok) window.location.hash = '#/statut';
  };

  return (
    <main className="ecran">
      <EnTeteRetour titre="PESÉE" retour="#/statut" />
      <Fenetre>
        <p className="message">À jeun, avant le petit-déjeuner.<br /><span className="muted" style={{ fontSize: 13 }}>Dernière pesée : {kg(etat.statut.poidsActuel)}</span></p>
        <input
          className="saisie"
          inputMode="decimal"
          autoFocus
          placeholder={etat.statut.poidsActuel?.toFixed(1).replace('.', ',') ?? '100,0'}
          value={saisie}
          onChange={(e) => setSaisie(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && void valider()}
          aria-label="Poids en kilos"
        />
        <div className="pas">
          <span style={{ fontSize: 14 }}>Fast-foods hors plan<br /><span className="muted" style={{ fontSize: 12 }}>cette semaine</span></span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <button className="btn petit" aria-label="Un de moins" onClick={() => setFastfoods(Math.max(0, fastfoods - 1))}>−</button>
            <b>{fastfoods}</b>
            <button className="btn petit" aria-label="Un de plus" onClick={() => setFastfoods(Math.min(21, fastfoods + 1))}>+</button>
          </div>
        </div>
        <button className="btn principal large" disabled={poids === null || envoi} onClick={() => void valider()}>{VOCAB.valider}</button>
      </Fenetre>
    </main>
  );
}
